import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

// Esta ruta debe coincidir con router.register('tipos-de-empleados-presupuestales', ...) en urls.py
export const baseURI = 'catalogos/tipos-de-empleados-presupuestales';

/**
 * GET Tipos de Empleados Presupuestales
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getTiposDeEmpleadosPresupuestales = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipo de Empleado Presupuestal
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getTipoDeEmpleadoPresupuestal = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Tipo de Empleado Presupuestal
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeEmpleadoPresupuestal = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de Empleado Presupuestal
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDeEmpleadoPresupuestal = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de Empleado Presupuestal
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteTipoDeEmpleadoPresupuestal = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Tipo de Empleado Presupuestal
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarTipoDeEmpleadoPresupuestal = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
